import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../../reuseableComp.tsx/Button";
import { InputDiv } from "../../reuseableComp.tsx/InputWithLogo";
import EmailIcon from "../../useIconpark/emailIcon";
import {
  MainWrapper,
  CenteredObject,
  CenteredContent,
  TextArea,
  TextPtag,
  ButtonArea,
  Error,
} from "../Signup/style";
import SecurityIcon from "../../useIconpark/security";
import BackLink from "../../reuseable/BackLink";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { ProgressBar } from "react-loader-spinner";
import OTPInput from "react-otp-input";
import { LittleSpace } from "../ModalComponent/AddNames/style";

const VerifyMail = () => {
  const [otp, setOtp] = useState("");
  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    if (!storedToken) {
      navigate("/login", { replace: true });
    }
  });

  const [resendCode, setResendCode] = useState(false);

  const payload = {
    code: otp,
  };

  const [errorMessage, setErrorMessage] = useState(false);
  const [error, seterror] = useState("");

  const verifyCode = () => {
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_BASE_ENDPOINT}/confirm`, payload, {
        headers: Authorization,
      })
      .then((res: any) => {
        setLoading(false);
        navigate("/upload-profile-picture");
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
        if (err.response.data.message === "Confirmation code has expired") {
          setErrorMessage(true);
          setResendCode(true);
          seterror(err.response.data.message);
        } else if (err.response.data.message === "Email Already Verified") {
          navigate("/upload-profile-picture");
        }
      });
  };

  const ResendCode = () => {
    axios
      .post(
        `${process.env.REACT_APP_API_BASE_ENDPOINT}/resend`,
        {},
        { headers: Authorization }
      )
      .then((res: any) => {
        setResendCode(false);
        setErrorMessage(false);
      })
      .catch((error: any) => {});
  };

  const width = window.innerWidth;

  return (
    <>
      <MainWrapper>
        <CenteredObject>
          <CenteredContent>
            <TextArea>
              <h2>Verify Your Email Address</h2>
            </TextArea>
            <TextPtag>
              <p>Enter the 6 digit code sent to your email.</p>
            </TextPtag>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                inputStyle={{
                  width: width > 728 ? "2.5rem" : "2.5rem",
                  height: width > 728 ? "2.5rem" : "2.5rem",
                  background: "#fff",
                  border: "1px solid #191919",
                  borderRadius: "4px",
                  textAlign: "center",
                  fontWeight: "bold",
                  marginRight: 15,
                  color: "black",
                }}
                renderSeparator={<span></span>}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <ButtonArea>
              <Button disabled={!otp} onClick={verifyCode}>
                {loading ? (
                  <>
                    <ProgressBar
                      height="60"
                      width="60"
                      ariaLabel="progress-bar-loading"
                      wrapperStyle={{}}
                      wrapperClass="progress-bar-wrapper"
                      borderColor="#F4442E"
                      barColor="#ffffff"
                    />
                  </>
                ) : (
                  <>Verify Email</>
                )}
              </Button>
            </ButtonArea>

            {errorMessage && (
              <>
                <LittleSpace>
                  <Error>
                    <p>{error}</p>
                  </Error>
                </LittleSpace>
              </>
            )}

            {resendCode && (
              <>
                <p>
                  Click{" "}
                  <span
                    onClick={ResendCode}
                    style={{ color: "blue", cursor: "pointer" }}
                  >
                    here
                  </span>{" "}
                  to get new code.
                </p>
              </>
            )}
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};

export default VerifyMail;
